import React, { useCallback, useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { PopperPlacements } from '../../popper';
import Popper from '../../popper/popper';
import PopoverListItem from './popover-list-item';
import VerticalMenuIcon from '../../../icons/vertical-menu-icon';
import TooltipButton from '../table-toolbar/views/tooltip-button/tooltip-button';
import { ButtonTypes } from '../../button';
import useTranslation from '../../../../utils/translation-utils';

const ConfigurableColumnsPopover = ({
  open, setOpen, columns, optionalColumns, onSelect,
}) => {
  const openPopoverCallback = useCallback(() => setOpen(true), []);
  const closePopoverCallback = useCallback(() => setOpen(false), []);
  const [getTranslation] = useTranslation();
  const filteredColumns = useMemo(() => columns.filter(({ label }) => label), [columns]);

  const getColumnConfigPopperView = () => (
    <div className="column-config-popper-view">
      {filteredColumns.map(({ optional, id, label }) => (
        <PopoverListItem
          id={id}
          name={label}
          optional={optional}
          onSelect={onSelect}
          selected={optionalColumns.includes(id)}
        />
      ))}
    </div>
  );

  return (
    <Popper
      open={open}
      onOpen={openPopoverCallback}
      onClose={closePopoverCallback}
      view={getColumnConfigPopperView()}
      placement={PopperPlacements.BOTTOM_END}
    >
      <div className="cc-btn-wrapper">
        <TooltipButton
          className="ccb-cont"
          renderIcon={VerticalMenuIcon}
          type={ButtonTypes.SECONDARY}
          description={open ? '' : getTranslation('CONFIGURE_COLUMNS')}
          borderLess
        />
      </div>
    </Popper>
  );
};

ConfigurableColumnsPopover.defaultProps = {
  open: false,
  columns: [],
  setOpen: () => {},
  onSelect: () => {},
  optionalColumns: [],
};

ConfigurableColumnsPopover.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })),
  onSelect: PropTypes.func,
  optionalColumns: PropTypes.arrayOf(PropTypes.string),
};

export default memo(ConfigurableColumnsPopover);
